import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import Header from "../../component/common/Header";
import Paging from "../../component/common/Paging";
import { removeAllCookies } from "../../utils";
import FileSearchBar from "./../../component/file/FileSearchBar";
import CONSTANT from "./../../constant";

import { getCookie, getDateParts } from "../../utils";
import { getOtherFileList } from "./../../actions/FileAction";
import { getVersion } from "./../../actions/MasterAction";

import { getBirthDayList } from "../../actions/UserAction";
import "../../assets/css/homepage.css";
import SessionOut from "../../component/SessionOut/SessionOut";

import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';

class ComponentName extends React.Component<any, any> {
    private searchTimeout: any = null;

    constructor(props: any) {
        super(props);
        const userDetail = getCookie(CONSTANT.cookie.userDetail);
        this.state = {
            page: 1,
            limit: 20,
            total: 0,
            initiatedFiles: undefined,
            pendingFiles: undefined,
            otherFiles: undefined,
            userDetail,
            sessionExpired: false,
            b_list: undefined,
            searchTerm: '', // Add search term
            isLoading: false, // Add loading state
            expandedSections: {
                outbox: true,
            },
        };
    }

    toggleSection = (section: string) => {
        this.setState((prevState: any) => ({
            expandedSections: {
                ...prevState.expandedSections,
                [section]: !prevState.expandedSections[section],
            },
        }));
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.allFiles;

        this.loadList();

        getVersion().then((res: any) => {
            if (CONSTANT.version.web < res.web) {
                window.location.reload();
            }
        });

        getBirthDayList()
            .then((res: any) => {
                this.setState({ b_list: res.result });
            })
            .catch((error: any) => {
                console.error("Error fetching birthday list:", error);
            });
    }

    componentWillUnmount() {
        // Clear timeout when component unmounts
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
    }

    handleSearch = (searchTerm: string) => {
        this.setState({ searchTerm });

        // Clear existing timeout
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        // Set new timeout for debouncing (wait 500ms after user stops typing)
        this.searchTimeout = setTimeout(() => {
            this.setState({ page: 1, isLoading: true }, () => {
                this.loadList();
            });
        }, 500);
    };

    render() {
        const {
            page,
            list,
            limit,
            total,
            initiatedFiles,
            pendingFiles,
            otherFiles,
            sessionExpired,
            searchTerm,
        } = this.state;

        if (sessionExpired) {
            return <SessionOut />;
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12 mb-3">
                        <div className="">
                            <div className="row">


                            </div>
                        </div>

                        <div className="card homedob p-4 mb-4">
                            {/* ADD THE TABBED HEADER HERE */}
                            <div className="stickytabs">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="tabbedt round mb-4">
                                        <ul>
                                            <li>
                                                <Link to={CONSTANT.component.userAddFile.url}>
                                                    Create New
                                                </Link>
                                            </li>
                                            <li>
                                                    <Link to={CONSTANT.component.partFile.url}>
                                                        Create Part File
                                                    </Link>
                                            </li>
                                            <li>
                                                <Link to={CONSTANT.component.DraftList.url}>
                                                    Submit for Approval
                                                </Link>
                                            </li>

                                            <li>
                                                <Link to={CONSTANT.component.myFiles.url}>
                                                    My Files
                                                </Link>
                                            </li>

                                            <li>
                                                <Link to={CONSTANT.component.inbox.url}>
                                                    Inbox
                                                </Link>
                                            </li>

                                            <li>
                                                <Link to={CONSTANT.component.outbox.url} className="active">
                                                    Outbox
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* END OF TABBED HEADER */}

                            
                            </div>
                            <div className="col-md-6">
                                    <FileSearchBar 
                                        onSearch={this.handleSearch}
                                        searchValue={searchTerm}
                                    />
                                </div>
                            {/* {otherFiles !== undefined && (
                                <div className='text-right w-100 mb-3'>
                                    <label>Select Range: </label>
                                    <select className="form-select p-2 px-4" value={limit} onChange={(e: any) => this.handleLimitChange(e.target.value)}>
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                        <option value="40">40</option>
                                        <option value="50">50</option>
                                    </select>
                                </div>
                            )} */}

                            <div className="row">
                                <div className="col-md-12 my-5">
                                    <div className="list-container">
                                        <div className="table-container">
                                            <div className="table-wrapper">
                                                <table className="tablen">
                                                    <thead>
                                                        <tr className="headbg">
                                                            <th colSpan={8} className="tabheadtitle">
                                                                Outbox
                                                            </th>
                                                        </tr>
                                                        {this.state.expandedSections.outbox && (
                                                            <tr>
                                                                <th className="text-nowrap">Comp. No.</th>
                                                                <th scope="col" className="text-nowrap">
                                                                    File Number
                                                                </th>
                                                                <th scope="col">Subject</th>
                                                                <th scope="col" className="text-nowrap">
                                                                    Sent To
                                                                </th>
                                                                <th scope="col" className="text-nowrap">
                                                                    Sent On
                                                                </th>
                                                                <th scope="col" className="text-nowrap">
                                                                    Currently With
                                                                </th>
                                                                {/* <th scope="col" className="text-nowrap">Currently With</th> */}
                                                                {/* <th scope="col" className="text-nowrap">Modified on</th> */}
                                                                {/* <th scope="col" className="text-nowrap">Read On</th> */}
                                                                {/* <th scope="col" className="text-nowrap">
                                Pending(Days)
                              </th> */}
                                                            </tr>
                                                        )}
                                                    </thead>
                                                    {this.state.expandedSections.outbox && (
                                                        <tbody>
                                                            {(otherFiles === undefined || this.state.isLoading) && (
                                                                <tr>
                                                                    <td colSpan={8} className="text-center">
                                                                        <div className="d-flex justify-content-center align-items-center py-3">
                                                                            <div className="spinner-border text-primary" role="status">
                                                                                <span className="sr-only">Loading...</span>
                                                                            </div>
                                                                            <span className="ml-2">Loading...</span>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}

                                                            {otherFiles !== undefined &&
                                                                !this.state.isLoading &&
                                                                otherFiles.length === 0 && (
                                                                    <tr>
                                                                        <td
                                                                            colSpan={8}
                                                                            className="text-center"
                                                                        >
                                                                            {searchTerm 
                                                                                ? "No files match your search" 
                                                                                : "No files found"}
                                                                        </td>
                                                                    </tr>
                                                                )}

                                                            {otherFiles !== undefined &&
                                                                !this.state.isLoading &&
                                                                otherFiles.map((item: any, index: number) => {
                                                                    const detailPageURL =
                                                                        CONSTANT.component.userFileDetail.url.replace(
                                                                            ":code",
                                                                            item.code
                                                                        );
                                                                    const dated = getDateParts(item.dated);
                                                                    const mo = getDateParts(item.dated);
                                                                    const subjectStr =
                                                                        item.subject.length > 50
                                                                            ? item.subject.substr(0, 100) + "..."
                                                                            : item.subject;

                                                                    const sd = moment(item.dated); //start date
                                                                    const ed = moment();
                                                                    const diff = Math.floor(
                                                                        moment.duration(ed.diff(sd)).asDays()
                                                                    );
                                                                    let diffCSSClassName = "";
                                                                    if (diff >= 0 && diff <= 7) {
                                                                        diffCSSClassName = "text-primary";
                                                                    } else if (diff > 7 && diff <= 14) {
                                                                        diffCSSClassName = "text-info";
                                                                    } else if (diff > 14 && diff <= 21) {
                                                                        diffCSSClassName = "text-warning";
                                                                    } else {
                                                                        diffCSSClassName = "text-danger";
                                                                    }

                                                                    return (
                                                                        <tr
                                                                            key={index}
                                                                            className="c-pointer"
                                                                            onClick={() =>
                                                                                this.openDetailPage(detailPageURL)
                                                                            }
                                                                        >
                                                                            <td className="sno">{item.code}</td>

                                                                            <td className="w-10">{item.fileNumber}</td>
                                                                            <td className="subject w-50" title={item.subject}>{subjectStr}</td>

                                                                            <td className="financial w-25">
                                                                                {item.sentTo}
                                                                            </td>
                                                                            <td className="w-10">
                                                                                <span className={item.latest_dated ? "status-badge modified text-nowrap" : ''}>
                                                                                    {item.latest_dated ?
                                                                                        moment(item.latest_dated).format(
                                                                                            "YYYY-MM-DD h:mm:ss A"
                                                                                        ) :
                                                                                        ""
                                                                                    }
                                                                                </span>
                                                                            </td>
                                                                            <td className="">
                                                                                <span
                                                                                    className={
                                                                                        item.isClosed
                                                                                            ? "status-badge  text-nowrap parked"
                                                                                            : "status-badge current-with text-nowrap"
                                                                                    }
                                                                                >
                                                                                    {item.isClosed
                                                                                        ? "Parked"
                                                                                        : item.currentlyWith}
                                                                                </span>
                                                                            </td>
                                                                            {/* <td
                                      className={`${diffCSSClassName} ${"text-center"}`}
                                    >
                                      <b>
                                        <span className="pending-days">
                                          {diff === 0 ? "Updated Today" : diff}
                                        </span>
                                      </b>
                                    </td> */}
                                                                        </tr>
                                                                    );
                                                                })}
                                                        </tbody>
                                                    )}
                                                </table>
                                                <div className='mt-4 p-4'>
                                                    {otherFiles !== undefined && otherFiles.length !== 0 && total > limit && (
                                                        <ResponsivePagination
                                                            activeItemClassName='Pagi-number-ac'
                                                            current={page}
                                                            maxWidth={1}
                                                            total={Math.ceil(total / limit)}
                                                            onPageChange={this.handlePageChange}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    loadList = (page: number = this.state.page, limit: number = this.state.limit) => {
        const { searchTerm } = this.state;
        this.setState({ isLoading: true }); // Set loading to true when starting request
        
        getOtherFileList(page, limit, searchTerm).then((res: any) => {
            if (res) {
                this.setState({
                    otherFiles: res.result?.otherFiles,
                    total: res.result?.total || 0,
                    isLoading: false, // Set loading to false when data is received
                });
            } else if (res == undefined) {
                this.setState(
                    (prev: any) => {
                        return {
                            ...prev,
                            sessionExpired: true,
                            isLoading: false, // Set loading to false on error
                        };
                    },
                    () => {
                        setTimeout(() => {
                            removeAllCookies();
                            localStorage.removeItem("timer");
                            this.props.history.push("/");
                        }, 3000);
                    }
                );
            }
        }).catch(() => {
            this.setState({ isLoading: false }); // Set loading to false on error
        });
    };

    handlePageChange = (newPage: number) => {
        this.setState({ page: newPage }, () => {
            this.loadList();
        });
    };

    handleLimitChange = (newLimit: number) => {
        this.setState({ limit: newLimit, page: 1 }, () => {
            this.loadList();
        });
    };

    handleUpdateDraftStatus = async (code: string) => {
        this.props.history.push({
            pathname: "/file/add",
            search: `?code=${code}`,
        });
    };

    openDetailPage = (url: string) => {
        this.props.history.push(url);
    };

    changePage = (e: any) => {
        const type = e.target.dataset.type;
        const page = type === "+" ? this.state.page + 1 : this.state.page - 1;
        this.setState({ page }, () => {
            this.loadList();
        });
    };
}

export default ComponentName;